import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

export default defineNuxtPlugin((nuxtApp) => {
  const { $pinia } = nuxtApp as Record<string, any>
  $pinia.use(piniaPluginPersistedstate)
})
